exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2b_IE-NC_aCXBWTIIImFUp{position:relative}._2pd-WCT-JuaQlaOUGVi6bV{margin:100px 0}\n", ""]);

// Exports
exports.locals = {
	"Popovers": "_2b_IE-NC_aCXBWTIIImFUp",
	"demoContainer": "_2pd-WCT-JuaQlaOUGVi6bV"
};